<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n/dist/vue-i18n.js';
import { useRoute, useRouter } from 'vue-router';

const names = {
    'en': "English",
    'nl': "Nederlands",
    'de': "Deutsch",
    'da': "Dansk",
    'pl': "Polski",
    'tr': "Türkçe",
    'hr': "Hrvatski",
    'sv': "Svenska",
    'pt': "Português",
    'pt-BR': "Português (Brasil)",
    'it': "Italiano",
    'es': "Español",
    'el': "Ελληνικά",
    'fr': "Français",
    'zh': "正體中文",
    'ro': "Română",
    'cs': "Čeština",
    'hu': "Magyar",
    'ko': "한국어",
    'sk': "Slovenský",
    'ru': "ру́сский язы́к"
}

const i18n = useI18n()
const route = useRoute()
const router = useRouter()

const currentLocale = computed(() => i18n.locale.value)
const locales = computed(() => i18n.availableLocales)

const switchLocale = (locale: string) => {
    router.push({
        name: 'home',
        params: { locale: locale },
        query: router.currentRoute.value.query,
        hash: router.currentRoute.value.hash
    })
    i18n.locale.value = locale
}

if (route.params.locale != undefined) {
    // this kinda sucks but it should never be a string[] and I'm not in the mood to properly type check this
    i18n.locale.value = <string>route.params.locale
}

const isActive = (locale: string) => (locale == i18n.locale.value)

</script>

<template>
    <div id="header-lang" class="clearfix">
        <div :data-code="currentLocale"></div>
        <ul>
            <li
                v-for="loc in locales"
                class="switch-lang" :data-code="loc"
                v-bind:class="{selected: isActive(loc)}"
                @click="switchLocale(loc)"
            >
                <span>{{ names[loc as keyof typeof names] }}</span>
            </li>
        </ul>
    </div>
</template>